module.exports = __webpack_public_path__ + "static/media/novo_globe_animation.1060df11.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/novo_globe_animation.mp4
// module id = 170
// module chunks = 0